/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Pc_Dl_Faq_A3Inputs */

const en_pc_dl_faq_a3 = /** @type {(inputs: Pc_Dl_Faq_A3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From an elevated terminal, run msiexec /i "pdfcraft-${i?.version}-windows-x64.msi" /qn /norestart. Add INSTALLDESKTOPSHORTCUT=0, INSTALLPDFCONTEXTMENU=0 or INSTALLIMAGECONTEXTMENU=0 to leave out the desktop shortcut or the right-click menu entries.`)
};

const zh_pc_dl_faq_a3 = /** @type {(inputs: Pc_Dl_Faq_A3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`在管理员终端中运行 msiexec /i "pdfcraft-${i?.version}-windows-x64.msi" /qn /norestart。加上 INSTALLDESKTOPSHORTCUT=0、INSTALLPDFCONTEXTMENU=0 或 INSTALLIMAGECONTEXTMENU=0 可以不安装桌面快捷方式或右键菜单项。`)
};

/**
* | output |
* | --- |
* | "From an elevated terminal, run msiexec /i \"pdfcraft-{version}-windows-x64.msi\" /qn /norestart. Add INSTALLDESKTOPSHORTCUT=0, INSTALLPDFCONTEXTMENU=0 or INSTA..." |
*
* @param {Pc_Dl_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_a3 = /** @type {((inputs: Pc_Dl_Faq_A3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_A3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_a3(inputs)
	return zh_pc_dl_faq_a3(inputs)
});
export { pc_dl_faq_a3 as "pc.dl.faq.a3" }